import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=58a847b4&scoped=true&"
import script from "./Templates.vue?vue&type=script&lang=js&"
export * from "./Templates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a847b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a847b4')) {
      api.createRecord('58a847b4', component.options)
    } else {
      api.reload('58a847b4', component.options)
    }
    module.hot.accept("./Templates.vue?vue&type=template&id=58a847b4&scoped=true&", function () {
      api.rerender('58a847b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Marketing/Templates.vue"
export default component.exports